import React from "react";
import {
  resolvePlatformLogo,
  handlePlatformLogoError,
  LOOPS_LOGO_SRC,
} from "../../utils/platformLogos";
import "./platform-logo.css";

/** Fixed logo box size — keep in sync with `.oh-platform-logo` in platform-logo.css */
export const PLATFORM_LOGO_BOX_SIZE = 40;

/** Minimum width for logo cells: 40px box + 14px horizontal cell padding each side */
export const ORDER_TABLE_PLATFORM_LOGO_MIN_WIDTH = PLATFORM_LOGO_BOX_SIZE + 28;

/**
 * Orders table platform column — tight fit for 40×40 logos + compact header.
 * Pair with `.orders-table-responsive .oh-table-*--platform` padding overrides in App.css.
 */
export const ORDER_TABLE_PLATFORM_COL_WIDTH = 96;

/**
 * Standardized platform logo — fixed 40×40 container with object-fit: contain.
 * Figma: https://www.figma.com/design/BSf2COF8k9LxgQnzx5IIAD/Onehub?node-id=290-22497
 */
const PlatformLogo = ({
  platform,
  size = PLATFORM_LOGO_BOX_SIZE,
  className = "",
  imgClassName = "",
}) => {
  const logo = resolvePlatformLogo(platform);
  const src = logo?.src || LOOPS_LOGO_SRC;
  const alt =
    logo?.alt ||
    (typeof platform === "string" ? platform : "Platform");

  return (
    <span
      className={`oh-platform-logo${className ? ` ${className}` : ""}`}
      style={
        size !== PLATFORM_LOGO_BOX_SIZE
          ? { width: size, height: size }
          : undefined
      }
    >
      <img
        src={src}
        alt={alt}
        className={`oh-platform-logo__img${imgClassName ? ` ${imgClassName}` : ""}`}
        onError={(event) => handlePlatformLogoError(event, platform)}
      />
    </span>
  );
};

export default PlatformLogo;
